import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({
  selector: '[appThrottleClick]',
})
export class ThrottleClickDirective implements OnInit, OnDestroy {
  @Input() public throttleTime = 700;
  @Output() public throttleClick = new EventEmitter();
  private clicks = new Subject();
  private subscription: Subscription;

  constructor() {}

  public ngOnInit(): void {
    this.subscription = this.clicks.pipe(throttleTime(this.throttleTime)).subscribe((event) => {
      this.throttleClick.emit(event);
    });
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  public clickEvent(event) {
    let target = event.srcElement;

    if (!target) {
      target = event.target;
    }

    const isDisabled = target.getAttribute('disabled');

    if (isDisabled === 'false' || isDisabled === null) {
      target.setAttribute('disabled', true);
      event.preventDefault();
      event.stopPropagation();
      this.clicks.next(event);
    }
  }
}
